/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { Footer, Icon, Menu, Profile } from "components";
import { Col, Row } from "components/Grid";
import {
  Container,
  ContentMenu,
  ContentProfile,
  Country,
  IconNotification,
  Logo,
  Main,
  Name,
  Photo,
  Scrollbox,
  Subtitle,
  Title,
  User,
} from "./styles";
import logoSimple from '../../../public/favicon.png';
import { HeaderMenu } from '@fitinsur/components';
import { GlobalAuthContext } from "store/context";
import { FitinsurAPI, MessageCenter } from "utils/src/index";
import TopHeader from "components/TopHeader/index";

const propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default function Layout({ children, title, subtitle, extraSubtitle }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [notifications, setNotifications] = useState(0);

  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const [user, setUser] = useState({
    name: "",
    country: "",
    policies: 0,
    claims: 0,
    enquiries: 0,
    paymentsLate: 0,
    schedule: [
      {
        name: "Petrobrás",
        date: "May 15th 2020",
      },
      {
        name: "Monsanto",
        date: "June 1st 2020",
      },
    ],
    remember: [],
  });

  async function getUserInfo() {
    //fitinsur.setAuthToken(authContext.token);
    // fitinsur
    //   .sidedrawerRemember()
    //   .then((res) => res.json())
    //   .then((data) => {
    //     if (data.ret_code !== 200) {
    //       mc.error(data.ret_msg_details);
    //       return;
    //     }

    //     const {
    //       numEnquiries,
    //       country,
    //       numClaims,
    //       numPayments,
    //       numPolices,
    //       remember,
    //     } = data.ret_value;

    //     setUser({
    //       ...user,
    //       country: country?.toString(),
    //       enquiries: numEnquiries,
    //       paymentsLate: numPayments,
    //       claims: numClaims,
    //       policies: numPolices,
    //       remember: remember,
    //     });

    //     setNotifications(numEnquiries + numClaims + numPayments + numPolices);
    //   });
  }

  useEffect(() => {
    if (
      authContext.status &&
      authContext.login_response &&
      authContext.login_response.ret_value &&
      authContext.login_response.ret_value.firstName
    ) {
      user.name =
        authContext.login_response.ret_value.firstName +
        " " +
        authContext.login_response.ret_value.lastName;
      user.country = authContext.user_region;
    }

    getUserInfo();
  }, []);

  return (
    <>
      <HeaderMenu 
          imgLogo={logoSimple}
          user={user}
          // notifications={newNotifications}
          showMenu={setShowMenu}
          showProfile={setShowProfile}
          project={'br'}
      />
      <Container style={{paddingTop: "10px"}}>
        <ContentMenu className={showMenu ? "menu-open" : "menu-close"}>
        <Icon name="close" className="icon-close" onClick={() => setShowMenu(false)} />
          <Menu showProfile={setShowProfile} />
        </ContentMenu>
        <Main>
          <Row>
            <Col sm={9} className="d-none d-sm-block p-0 p-md-2">
              <Title>{title}</Title>
              <Subtitle>{subtitle}</Subtitle>
              {extraSubtitle && <Subtitle>{extraSubtitle}</Subtitle>}
            </Col>
            <Col xs={12} className="d-sm-none pl-2 pr-2 p-md-3">
              <Title>{title}</Title>
              <Subtitle>{subtitle}</Subtitle>
            </Col>
          </Row>
          <Scrollbox>{children}</Scrollbox>
        </Main>
        <ContentProfile className={showProfile ? "profile-open" : ""}>
          <Icon
            name="close"
            className="icon-close"
            onClick={() => setShowProfile(false)}
          />
          <Profile user={user} />
        </ContentProfile>
      </Container>
      <Footer />
    </>
  );
}

Layout.propTypes = propTypes;
